// For more help visit https://formspr.ee/react-help
import React from 'react';
import { useForm, ValidationError } from '@formspree/react';

function ContactForm() {
    const [state, handleSubmit] = useForm("mayaeooo");
    if (state.succeeded) {
        return (
            <section id="contact">
                <header className="section-header">
                    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44"><path d="M21.856 10.303c.086.554.144 1.118.144 1.697 0 6.075-4.925 11-11 11s-11-4.925-11-11 4.925-11 11-11c2.347 0 4.518.741 6.304 1.993l-1.422 1.457c-1.408-.913-3.082-1.45-4.882-1.45-4.962 0-9 4.038-9 9s4.038 9 9 9c4.894 0 8.879-3.928 8.99-8.795l1.866-1.902zm-.952-8.136l-9.404 9.639-3.843-3.614-3.095 3.098 6.938 6.71 12.5-12.737-3.096-3.096z" /></svg>
                    <h3>Thanks! We'll respond as soon as we can.</h3>
                    <p>In the meantime, enjoy this free .gif</p>
                </header>
                <div className="section-content">
                    <img src="https://media.giphy.com/media/3oEjI53nBYOOEQgDcY/giphy.gif?cid=ecf05e47hq1tf32jagz4tlwp5bkq48o1194kqraedqwhnlhl&rid=giphy.gif&ct=g" alt=" " />
                </div>
            </section>
        );

    }
    return (
        <section id="contact">
            <header className="section-header">
                <h2>Contact</h2>
                <p>Contact us for more information about our services. We'll reply as quickly as we can.</p>

            </header>
            <div className="section-content">
                <form onSubmit={handleSubmit}>
                    <label htmlFor="email">
                        <h3>Email Address</h3>
                    </label>
                    <input
                        id="email"
                        type="email"
                        name="email"
                        placeholder="enter your email address"
                        required="true"
                    />
                    <ValidationError
                        prefix="Email"
                        field="email"
                        errors={state.errors}

                    />
                     <label htmlFor="email">
                        <h3>Message</h3>
                    </label>
                    <textarea
                        id="message"
                        name="message"
                        placeholder="enter your message"
                        required="true"

                    />
                    <ValidationError
                        prefix="Message"
                        field="message"
                        errors={state.errors}
                    />
                    <button class="submit" type="submit" disabled={state.submitting}>
                        Submit
                    </button>
                </form>
            </div>
        </section>
    );
}
function App() {
    return (
        <ContactForm />
    );
}
export default App;


// WEBPACK FOOTER //
// ./src/components/Contact.js